module.exports = __webpack_public_path__ + "img/sample-softwareEngineer.14e39911.webp";